import React from "react";
import OrderPage from "feature/orders/order-page";
import {OrdersProvider} from "feature/orders/use-orders";

const OrdersContainer = () => {
  return (
    <OrdersProvider>
      <OrderPage />
    </OrdersProvider>
  );
};

export default OrdersContainer;
